import { env } from "@/env";

export const PENDING_ACTIONS = {
  COMPLETE_SURVEY: "pending_survey",
} as const;

export const PROFILING_ERRORS = {
  RESUME: "resume_failed",
} as const;

export const PROFILING_IFRAME_PARAM_KEY = "profiling_iframe_url";
export const PROFILING_IFRAME_BASE_URL = `${env.VITE_APP_URL}/profiling`;

// Error codes the /login route renders via ?error=…. Closed enum so the page
// can map codes to friendly messages with type safety; unknown values (rare
// IdP-passthrough errors from the backend) are dropped to undefined at parse
// time and rendered as a generic toast.
export const LOGIN_ERRORS = {
  MISSING_TOKEN: "missing_token",
  INVALID_SESSION: "invalid_session",
  OIDC_ONBOARDING_EXCHANGE_FAILED: "oidc_onboarding_exchange_failed",
  OIDC_ONBOARDING_STATUS_FAILED: "oidc_onboarding_status_failed",
  MISSING_CODE_OR_STATE: "missing_code_or_state",
  OIDC_ERROR: "oidc_error",
  ACCESS_DENIED: "access_denied",
} as const;

// Relief scale shown to the patient. `value` is the SymptomsRelief backing value
// in eo-back (src/Surveys/Domain/Enums/SymptomsRelief.php) — it is what we submit,
// so the display copy (with its trailing period) can change without breaking the model.
export const RELIEF_OPTIONS = [
  { label: "No relief.", value: "not_enough_relief" },
  { label: "A little relief.", value: "minimal_relief" },
  { label: "Moderate relief.", value: "moderate_relief" },
  { label: "A lot of relief.", value: "good_relief" },
  { label: "Complete relief.", value: "great_relief" },
] as const;

export const PRODUCT_TYPE_LABELS: Record<string, string> = {
  beverage_edible: "beverage",
  gummy_edible: "gummies",
  lotion_topical: "lotion",
  tincture: "tincture",
  pill_edible: "pill",
  inhaler: "inhaler",
};

// The only side effects fed into the recommendation model. Matched against the labels
// emitted by SideEffect::label() in eo-back (src/Products/Domain/Enums/SideEffect.php).
// Intensity is asked only for these three.
export const INTENSITY_SIDE_EFFECTS = [
  "Dizziness",
  "Anxiety or racing heartbeat",
  "Too intoxicated (effects too strong)",
] as const;

// 1-5 intensity scale asked per relevant side effect. The numeric value maps
// directly to the backend severity phrase.
export const SIDE_EFFECT_INTENSITY_OPTIONS = [
  { label: "Very mild", value: 1 },
  { label: "Mild", value: 2 },
  { label: "Moderate", value: 3 },
  { label: "Severe", value: 4 },
  { label: "Very severe", value: 5 },
] as const;

export const getRelevantSideEffects = (selected: string[] | undefined): string[] => {
  return (selected ?? []).filter((sideEffect) => {
    return (INTENSITY_SIDE_EFFECTS as readonly string[]).includes(sideEffect);
  });
};
